import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingSpinner from "../composant_reutilisable/loading";

const VerificationCode = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [code, setCode] = useState("");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [remainingTime, setRemainingTime] = useState(0); // secondes
    const [canResend, setCanResend] = useState(false);

    // ref pour stocker l'ID de l'interval et éviter les doublons
    const intervalRef = useRef(null);

    // Données passées depuis l'étape précédente
    const { email, code_expires_at } = location.state || {};

    // redirection si pas d'email
    useEffect(() => {
        if (!email) {
            navigate("/");
        }
    }, [email, navigate]);

    // fonction utilitaire pour afficher alertes
    const showAlert = (message, type = "danger") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 1500);
    };

    // démarre / redémarre le compte à rebours à partir d'une date d'expiration ISO ou Date
    const startCountdown = (expiresAtIso) => {
        // clear ancien interval si présent
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (!expiresAtIso) {
            setRemainingTime(0);
            setCanResend(true);
            return;
        }

        const expiresAt = new Date(expiresAtIso).getTime();
        if (isNaN(expiresAt)) {
            setRemainingTime(0);
            setCanResend(true);
            return;
        }

        const update = () => {
            const now = Date.now();
            const diffSec = Math.max(0, Math.floor((expiresAt - now) / 1000));
            setRemainingTime(diffSec);
            if (diffSec <= 0) {
                // expired
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                setCanResend(true);
            }
        };

        // initialiser l'état immédiatement
        update();
        setCanResend(false);

        // lancer interval
        intervalRef.current = setInterval(update, 1000);
    };

    // formatter mm:ss
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, "0");
        const s = (seconds % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    useEffect(() => {
        // 🔁 Récupérer d'abord depuis localStorage s'il y a une valeur plus récente
        const savedExpiration = localStorage.getItem("code_expires_at");
        const effectiveExpiration = savedExpiration || code_expires_at;

        if (!effectiveExpiration) {
            setCanResend(true);
            return;
        }

        const expirationTime = new Date(effectiveExpiration).getTime();

        const interval = setInterval(() => {
            const now = Date.now();
            const diff = Math.floor((expirationTime - now) / 1000);

            if (diff <= 0) {
                clearInterval(interval);
                setRemainingTime(0);
                setCanResend(true);
                localStorage.removeItem("code_expires_at"); // 🔒 Nettoyage
            } else {
                setRemainingTime(diff);
                setCanResend(false);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [code_expires_at]);


    // soumettre le code
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!code.trim()) return showAlert("Veuillez entrer le code de confirmation.");

        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/verifier-code/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, code }),
            });
            const data = await response.json();
            setIsLoading(false);

            if (response.ok && data.success) {
                localStorage.setItem("token", data.token);
                localStorage.setItem("userId", data.utilisateur.id);
                // showAlert("Code vérifié avec succès !", "success");
                // on nettoie interval & localStorage code_expires si besoin
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                localStorage.removeItem("code_expires_at");
                // setTimeout(() => navigate("/Menu"), 800);
                navigate("/Menu");
            } else {
                showAlert(data.message || "Code incorrect ou expiré.", "danger");
            }
        } catch (error) {
            setIsLoading(false);
            showAlert("Erreur de connexion au serveur.", "danger");
        }
    };

    // renvoyer le code
    const handleResendCode = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/renvoyer-code/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            setIsLoading(false);

            if (response.ok && data.success) {
                showAlert("Un nouveau code vous a été envoyé !", "success");

                setCode("");
                // backend doit renvoyer la nouvelle expiration; j'attends la propriété 'code_expires_at'
                const newExpires = data.code_expires_at || (data.utilisateur && data.utilisateur.code_expires_at);
                if (newExpires) {
                    // stocker si tu veux garder la valeur entre reloads
                    localStorage.setItem("code_expires_at", newExpires);
                    // relancer le countdown proprement
                    startCountdown(newExpires);
                } else {
                    // fallback : activer resend si pas d'info
                    setCanResend(true);
                }
            } else {
                showAlert(data.message || "Erreur lors du renvoi du code.", "danger");
            }
        } catch (error) {
            setIsLoading(false);
            showAlert("Erreur réseau. Veuillez réessayer.", "danger");
        }
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="loginColumns animated fadeInDown"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                        // backgroundColor: "#f8f9fa",
                    }}
                >
                    <div
                        className="ibox shadow-lg"
                        style={{
                            width: "100%",
                            maxWidth: "420px",
                            backgroundColor: "#fff",
                        justifyContent: "center",

                            borderRadius: "12px",
                            padding: "30px",
                        }}
                    >
                        <div className="ibox-content text-center">
                            <h3 style={{ color: "#213b5e", fontWeight: "bold" }}>
                                Vérification du code
                            </h3>
                            <p className="text-muted">
                                Un code à 6 chiffres a été envoyé à : <br />
                                <strong>{email}</strong>
                            </p>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`} role="alert">
                                    {alert.message}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <label>Entrez le code de confirmation :</label>
                                    <input
                                        type="text"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        className="form-control text-center"
                                        placeholder="Ex : 123456"
                                        maxLength={6}
                                        // ✅ on désactive le champ seulement si le code est expiré
                                        disabled={canResend}
                                        style={{ fontSize: "1.2rem", letterSpacing: "3px" }}
                                    />
                                </div>

                                {/* ⏳ Timer ou message d’expiration */}
                                {!canResend ? (
                                    <p className="text-muted">
                                        ⏳ Temps restant : <strong>{formatTime(remainingTime)}</strong>
                                    </p>
                                ) : (
                                    <p className="text-danger fw-bold">⏰ Le code a expiré.</p>
                                )}

                                {/* ✅ Interversion entre les deux boutons */}
                                {!canResend ? (
                                    <button
                                        type="submit"
                                        className="btn btn-success w-100 mt-2"
                                        style={{ borderRadius: "8px" }}
                                    >
                                        <strong>Confirmer</strong>
                                    </button>
                                ) : (
                                    <button
                                        type="button" // ✅ éviter le submit par défaut
                                        onClick={handleResendCode}
                                        className="btn btn-success w-100 mt-2"
                                        style={{ borderRadius: "8px" }}
                                    >
                                        Renvoyer le code
                                    </button>
                                )}
                            </form>

                            {/* <div className="mt-3">
              <button
                className="btn btn-link text-secondary"
                onClick={() => navigate("/")}
              >
                Retour à la connexion
              </button>
            </div> */}
                        </div>

                        <div className="text-center mt-4">
                            <small>
                                <a
                                    href="https://www.adnservicespro.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#3088C0" }}
                                >
                                    ADN Services
                                </a>{" "}
                                &copy; {new Date().getFullYear()}. Tous droits réservés | Réalisé
                                par{" "}
                                <a
                                    href="https://inovact.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#3088C0" }}
                                >
                                    INOVACT SARL
                                </a>
                            </small>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

};

export default VerificationCode;
